export default __webpack_public_path__ + "static/media/link2.7997405d.svg";